import React, { useState, useEffect } from "react";

const initialForm = {
  componentName: "",
  type: "Earning",
  calculationType: "Fixed",
  amount: "",
  taxable: true,
  status: "Active",
};

const SalaryComponentModal = ({
  isOpen,
  onClose,
  onSave,
  initialData,
}) => {
  const [formData, setFormData] = useState(initialForm);

  useEffect(() => {
    if (initialData) {
      setFormData(initialData);
    } else {
      setFormData(initialForm);
    }
  }, [initialData]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        name === "taxable"
          ? value === "true"
          : value,
    }));
  };

  const handleSubmit = () => {
    if (
      !formData.componentName.trim() ||
      formData.amount === ""
    ) {
      alert("Please fill all required fields.");
      return;
    }

    onSave({
      ...formData,
      amount: Number(formData.amount),
    });

    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="finance-modal">

        <div className="finance-modal-header">
          <h2>
            {initialData
              ? "Edit Salary Component"
              : "Add Salary Component"}
          </h2>
        </div>

        <div className="finance-modal-body">

  <div className="form-row">
    <div className="form-group">
      <label>Component Name *</label>
      <input
        type="text"
        name="componentName"
        value={formData.componentName}
        onChange={handleChange}
      />
    </div>
  </div>

  <div className="form-row">

    <div className="form-group">
      <label>Type</label>
      <select
        name="type"
        value={formData.type}
        onChange={handleChange}
      >
        <option>Earning</option>
        <option>Deduction</option>
      </select>
    </div>

    <div className="form-group">
      <label>Calculation Type</label>
      <select
        name="calculationType"
        value={formData.calculationType}
        onChange={handleChange}
      >
        <option>Fixed</option>
        <option>Percentage</option>
      </select>
    </div>

  </div>

  <div className="form-row">

    <div className="form-group">
      <label>Amount *</label>
      <input
        type="number"
        name="amount"
        value={formData.amount}
        onChange={handleChange}
      />
    </div>

    <div className="form-group">
      <label>Taxable</label>
      <select
        name="taxable"
        value={formData.taxable}
        onChange={handleChange}
      >
        <option value={true}>Yes</option>
        <option value={false}>No</option>
      </select>
    </div>

  </div>

  <div className="form-row">

    <div className="form-group">
      <label>Status</label>
      <select
        name="status"
        value={formData.status}
        onChange={handleChange}
      >
        <option>Active</option>
        <option>Inactive</option>
      </select>
    </div>

  </div>

</div>

        <div className="finance-modal-footer">

          <button
            className="action-btn"
            onClick={onClose}
          >
            Cancel
          </button>

          <button
            className="action-btn edit-btn"
            onClick={handleSubmit}
          >
            Save
          </button>

        </div>

      </div>
    </div>
  );
};

export default SalaryComponentModal;